import React from "react";
import PropTypes from "prop-types";
import ClassNames from "classnames";

const CheckMark = ({ isChecked, visible, label }) => {
    if (visible) {
        var classNames = ClassNames("glyphicon", "glyphicon-ok");
        if (isChecked) {
            classNames = ClassNames(classNames, "ok-success");
        }
        else {
            classNames = ClassNames(classNames, "ok-default");
        }
        return (<div className="p-t-15">
            <span className={classNames}/>

            <span className="m-l-15 "> {label}</span>

        </div>);
    }
    return null;
};

CheckMark.propTypes = {
    visible: PropTypes.bool,
    isChecked: PropTypes.bool,
    label: PropTypes.string
};

export default CheckMark;
